module.exports = __webpack_public_path__ + "static/media/paybox-dark.321bd555.svg";